import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Tickets = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [tickets, setTickets] = useState([]);
  const [search, setSearch] = useState("");

  const statusBadge = (status) => {
    const map = {
      Open: "bg-emerald-100 text-emerald-700",
      "In Progress": "bg-blue-100 text-blue-700",
      Pending: "bg-yellow-100 text-yellow-800",
      Closed: "bg-red-100 text-red-700",
    };

    return map[status] || "bg-gray-100 text-gray-700";
  };

  useEffect(() => {
    loadTickets();
  }, []);

  const loadTickets = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/getIncident.php`,
      );

      const data = await res.json();

      if (data.success) {
        setTickets(data.incidents || []);
      }
    } catch (err) {
      console.error("Error loading tickets:", err);
    }
  };

  const filteredTickets = tickets.filter((t) => {
    const q = search.toLowerCase();

    return (
      t.title?.toLowerCase().includes(q) ||
      String(t.id).includes(q) ||
      t.created_by_name?.toLowerCase().includes(q) ||
      t.status?.toLowerCase().includes(q) ||
      t.priority?.toLowerCase().includes(q)
    );
  });

  const openTicket = (id) => {
    navigate(`/incidents/${id}`);
  };

  return (
    <div className="bg-[#f4f6fb] p-4 m-2 rounded-2xl min-h-[calc(100%-1rem)]">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-2xl font-bold text-[#0f2d56]">Incident Tickets</h1>

        <div className="w-full md:w-80">
          <input
            type="text"
            placeholder="Search tickets..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* DESKTOP TABLE */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="p-4">ID</th>
              <th className="p-4">Title</th>
              <th className="p-4">Created By</th>
              <th className="p-4">Status</th>
              <th className="p-4">Priority</th>
            </tr>
          </thead>

          <tbody>
            {filteredTickets.length > 0 ? (
              filteredTickets.map((t) => (
                <tr
                  key={t.id}
                  onClick={() => openTicket(t.id)}
                  className="border-t hover:bg-blue-50 cursor-pointer transition"
                >
                  <td className="p-4 font-bold text-[#0f2d56]">INC-{t.id}</td>

                  <td className="p-4">{t.title}</td>

                  <td className="p-4">{t.created_by_name}</td>

                  <td className="p-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${statusBadge(
                        t.status,
                      )}`}
                    >
                      {t.status}
                    </span>
                  </td>

                  <td className="p-4">{t.priority}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-10 text-gray-500">
                  No tickets found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MOBILE VIEW */}
      <div className="md:hidden space-y-3">
        {filteredTickets.length > 0 ? (
          filteredTickets.map((t) => (
            <div
              key={t.id}
              onClick={() => openTicket(t.id)}
              className="bg-white rounded-2xl shadow p-4 border cursor-pointer active:scale-[0.98] transition"
            >
              <div className="flex justify-between items-start gap-3 mb-3">
                <div>
                  <p className="font-bold text-lg text-[#0f2d56]">INC-{t.id}</p>

                  <p className="text-sm text-gray-500">{t.created_by_name}</p>
                </div>

                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${statusBadge(
                    t.status,
                  )}`}
                >
                  {t.status}
                </span>
              </div>

              <div className="mb-3">
                <p className="font-medium text-gray-800">{t.title}</p>
              </div>

              <div className="flex justify-between text-sm">
                <span>
                  <span className="font-semibold">Priority:</span> {t.priority}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="bg-white rounded-2xl shadow p-6 text-center text-gray-500">
            No tickets found
          </div>
        )}
      </div>
    </div>
  );
};

export default Tickets;
